import { PageModel } from "../../models";

import { mockRouteModel } from "./mock-route";

export function mockPageModel({
    id = "page-1234",
    type = "page",
    locale = "en",
    content = mockPageModelContent()
}: Partial<PageModel> = {}): PageModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type PageModelContent = PageModel["content"];

export function mockPageModelContent({
    title = "Example page",
    route = mockRouteModel(),
    ...optionals
}: Partial<PageModelContent> = {}): PageModelContent {
    return {
        title,
        route,
        ...optionals
    };
}
